import React from 'react';
import { List } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import formFieldTypes from '@/forms/constants';
import FormItemDescription from '@/forms/components/FormItemDescription';
import Selectors from '../../hooks/selectors';

const CatalogueUpdatedOnListItem = ({ category, code }) => {
  const { updatedOn } = Selectors.useDatasetUpdatedOn({ category, code });
  return (
    <List.Item className="aridhia-catalogue-updated-on-list-item">
      <List.Header>
        <FormattedMessage id="dataset.catalogue.updated.on.title" />
      </List.Header>
      <FormItemDescription text={updatedOn} field={{ type: formFieldTypes.DATE.type }} />
    </List.Item>
  );
};

export default CatalogueUpdatedOnListItem;
